import { render, staticRenderFns } from "./SHAPValues.vue?vue&type=template&id=622840fa&"
import script from "./SHAPValues.vue?vue&type=script&lang=js&"
export * from "./SHAPValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports